
import "../../../config";
import {Component, Prop, VModel, Mixins} from "vue-property-decorator";
import {
  getTenantById,
  updateTenant,
} from "../../../services/auth-service";
import PazTooltipButton from "../../../components/controls/PazTooltipButton.vue";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";
import {ITenant} from "@pazion/pazion-core/src/models/models";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import AuthUsermixin from "@pazion/pazion-core/src/mixins/AuthUser.mixin";

@Component({
  components: {
    PazTooltipButton,
    PazLoader,
  },
})
export default class pazTenantEditDialog extends Mixins(PermissionService, AuthUsermixin) {


  $refs!: {
    tenantForm: HTMLFormElement;
  };

  @VModel({
    default: false,
  })
  public showEditTenantDialog!: boolean;

  @Prop({ default: null }) tenantId!: number | null;
  @Prop({ default: false }) isPage?: boolean;

  public loading: boolean = false;
  public feedback: string = "";
  public name: string = "";
  public nameTech?: string = "";
  public accountReference?: string = "";
  public isActiveTenant: boolean = false;
  public tenantFormModel: boolean = false;
  created() {
    this.loading = true;
  }

  async handleSubmit() {
    this.$refs.tenantForm.validate();
    if (!this.tenantFormModel) return;
    this.loading = true;
    const tenantId = (this.tenantId && this.tenantId) || 0;
    let tenantData: object = {
      name: this.name,
      nameTech: this.nameTech,
      accountReference: this.accountReference,
      isActive: this.isActiveTenant,
    };
    const rsp = await updateTenant(tenantId, tenantData);
    if (rsp.id > 0) {
      if(!this.isPage) {
        this.showEditTenantDialog = false;
        this.$emit("onTenantChange");
        return
      }
      this.loading = false;
      await this.fetchData();
      if ( this.canCloseModal() )
        this.$router.push({name: 'Home'})
    } else {
      if (rsp && !rsp.success && rsp.hasOwnProperty("message")) {
        this.feedback = rsp.message;
      } else {
        this.feedback = "Unknown error, see the logs";
      }
      this.loading = false;
    }
  }


  canCloseModal() {
    return (!this.showTwoFactor || !this.isPage) || (this.showTwoFactor && this.hasTwoFactor);
  }

  mounted() {
    this.fetchData();
  }

  setData(obj: object) {
    this.name = obj.name;
    this.nameTech = obj.nameTech;
    this.accountReference = obj.accountReference;
    this.isActiveTenant = obj.isActive;
  }

  async fetchData() {
    if (this.tenantId) {
      const rsp = await getTenantById(this.tenantId);
      if (rsp != null) {
        this.setData(rsp);
      }
    }
    this.loading = false;
  }

  get isLoading() {
    return this.loading;
  }

}
